import InfoFillGrayIcon from '@/assets/icons/InfoFillGrayIcon.svg?react';

const NeedInviteManager = () => {
  return (
    <div className="flex w-fit gap-1 rounded-[8px] bg-gr-100 px-[6px] py-[4px]  text-gr-700 Caption1M12 ">
      <InfoFillGrayIcon />
      매니저를 등록하면 리뷰 확인이 가능해요!
    </div>
  );
};

export default NeedInviteManager;
